module.exports = __webpack_public_path__ + "static/img/wx.ddc3fa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wx.png
// module id = 3mnI
// module chunks = 1